import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var TagIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 20 20" }),
    React.createElement("path", { d: "M2.3 11.7l6 6c.2.2.4.3.7.3s.5-.1.7-.3l8-8c.2-.2.3-.4.3-.7V3c0-.6-.4-1-1-1h-6c-.3 0-.5.1-.7.3l-8 8c-.4.4-.4 1 0 1.4zM13 6c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z" }))); };

export { TagIcon as default };
